import { memo } from 'react';
import { RegionsEnum } from 'src/generated/operations';
import { I18n } from 'src/modules/common/components/I18n/I18n';
import { UserInput } from 'src/modules/user-input/types';
import { FormFieldNames } from 'src/modules/user-input/FormFieldNames.ts';
import { getUserInputFormFieldKey } from 'src/modules/common/hooks/getUserInputFormFieldKey.ts';

type Props = {
    region: RegionsEnum;
    state: UserInput;
    is6WayRequired: boolean;
}

export const ValvesTooltipValue = memo(({ region, state, is6WayRequired }: Props) => {
    const content = FormFieldNames
        .filter((name) => {
            if (!is6WayRequired && name.includes('2')) {
                return false;
            }
            return state[name];
        })
        .map((name) => (
            <div key={`valves-tooltip_${name}`} className="vss-valves-tooltip-value__row">
                <p className="vss-valves-tooltip-value__label">
                    <I18n messageId={getUserInputFormFieldKey(region, name)}/>
                </p>
                <p className="vss-valves-tooltip-value__value">
                    {state[name]} <I18n messageId={state[`${name}_u`]}/>
                </p>
            </div>
        ));
    return (
        <div className="vss-valves-tooltip-value">
            {content}
        </div>
    );
});
